import { render, staticRenderFns } from "./TheBlank.vue?vue&type=template&id=778575f3&scoped=true&"
import script from "./TheBlank.vue?vue&type=script&lang=js&"
export * from "./TheBlank.vue?vue&type=script&lang=js&"
import style0 from "./TheBlank.vue?vue&type=style&index=0&id=778575f3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "778575f3",
  null
  
)

export default component.exports